import React from 'react';
import { Box, Typography, Button, Container, Stack } from '@mui/material';
import { CheckCircle, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Redirigir al home o a la página principal
    navigate('/');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <CheckCircle
          sx={{
            fontSize: 80,
            color: 'success.main',
            mb: 3,
          }}
        />

        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2.125rem' },
          }}
        >
          ¡Pago exitoso!
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            maxWidth: 400,
            lineHeight: 1.6,
            fontSize: '1.1rem',
          }}
        >
          Tu pago se ha procesado correctamente. Recibirás un comprobante por
          correo electrónico en breve.
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            onClick={handleGoHome}
            startIcon={<Home />}
            sx={{
              py: 1.5,
              px: 3,
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Volver al inicio
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default PaymentSuccessPage;
